import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "37.252",
  viewBox: "0 0 37.252 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M0 0v50h23.284v-3.676H3.432V3.677h19.852V0zm24.482 13.278l-2.478 2.41 8.388 8.085H7.596v3.674h22.76l-8.3 8.09 2.452 2.45L37.25 25.64z"
  })]
});